// extracted by mini-css-extract-plugin
export default {"containerHeader":"Header_containerHeader__81jlC","logo":"Header_logo__hLUwo","containerMenu":"Header_containerMenu__Qz+qS","botao":"Header_botao__z8zO4"};